(function(){
"use strict";
/* I numeri salgono quando la sezione entra in vista: partono da zero
   e si fermano sul valore vero. */
var box=document.querySelector(".dh2 .numeri");
if(!box)return;
var celle=box.querySelectorAll("b[data-a]");
var fatto=false;

function formatta(v,dec,suf){
 var n=dec ? (v/Math.pow(10,dec)).toFixed(dec).replace(".",",")
           : Math.round(v).toLocaleString("it-IT");
 return n+(suf||"");
}

function sali(){
 if(fatto)return;
 fatto=true;
 for(var i=0;i<celle.length;i++){
  (function(el){
   var meta=Number(el.getAttribute("data-a"))||0;
   var dec=Number(el.getAttribute("data-dec"))||0;
   var suf=el.getAttribute("data-suf")||"";
   var t0=null, durata=1400;
   function passo(t){
    if(!t0)t0=t;
    var p=Math.min((t-t0)/durata,1);
    var e=1-Math.pow(1-p,3);
    el.textContent=formatta(meta*e,dec,p<1?"":suf);
    if(p<1)requestAnimationFrame(passo);
   }
   requestAnimationFrame(passo);
  })(celle[i]);
 }
}

if("IntersectionObserver" in window){
 var oss=new IntersectionObserver(function(voci){
  for(var i=0;i<voci.length;i++)if(voci[i].isIntersecting){sali();oss.disconnect()}
 },{threshold:.35});
 oss.observe(box);
}else sali();

/* Solo la freccia in basso scende al cercatore: il pulsante principale
   porta alla collection, quindi non va intercettato. */
var giu=document.querySelector('.dh2 .giu');
if(giu)giu.addEventListener("click",function(e){
 var meta=document.querySelector(".dtrova");
 if(!meta)return;
 e.preventDefault();
 scrollTo({top:meta.getBoundingClientRect().top+pageYOffset-60,behavior:"smooth"});
});
})();
